module.exports = __webpack_public_path__ + "static/media/download_white.aab1e424.svg";